import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

// Validation Rules
const required = value => (value ? undefined : "Required");

export const renderField = ({ input, label, type, style, meta: { touched, error, warning } }) => (
  <div>
    <input {...input} type={type} style={style} />

    {touched &&
      ((error && <div className="field__error">{error}</div>) ||
        (warning && <div className="field__error">{warning}</div>))}
  </div>
);

renderField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};

export const renderFieldWithLabel = ({
  input,
  label,
  type,
  style,
  meta: { touched, error, warning },
}) => (
  <div style={{ display: "flex", alignItems: "center", padding: 5 }}>
    {label && <label>{label}</label>}
    <div style={{ flexGrow: 1 }}>
      <input {...input} type={type} style={{ ...style, width: "100%" }} />

      {touched &&
        ((error && <div className="field__error">{error}</div>) ||
          (warning && <div className="field__error">{warning}</div>))}
    </div>
  </div>
);

renderFieldWithLabel.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  meta: PropTypes.object,
};

export const renderRadioButton = ({ input, type, style, meta: { touched, error, warning } }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
    <label>{input.value}</label>
    <input type={type} {...input} style={style} />

    {touched &&
      ((error && <div className="field__error">{error}</div>) ||
        (warning && <div className="field__error">{warning}</div>))}
  </div>
);

renderRadioButton.propTypes = {
  input: PropTypes.object,
  type: PropTypes.string, // need to pass type="radio" for Field to get the value for input
  style: PropTypes.object,
  meta: PropTypes.object,
};

const RadioButton = props => {
  let fieldValidation = [];

  if (props.column == "Emp") {
    fieldValidation = [required];
  }

  let style;
  if (props.optionsIndex == props.optionsLength - 1) {
    style = {
      textAlign: "center",
      borderRight: "1px solid #000",
      ...props.style,
    };
  } else {
    style = { textAlign: "center", ...props.style };
  }

  return (
    <td style={style}>
      <Field
        name={props.column + props.questionId}
        type="radio"
        component={renderField}
        value={props.value}
        validate={fieldValidation}
      />
    </td>
  );
};

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  optionsIndex: PropTypes.number.isRequired,
  optionsLength: PropTypes.number.isRequired,
  column: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export const RadioButtonGroupRow = props => {
  const style = {
    paddingLeft: 30,
    borderLeft: "1px solid #000",
    borderRight: "1px solid #000",
    ...props.style,
  };

  const elements = [];

  elements.push(
    <td style={style} key={props.questionId}>
      {props.questionDesc}
    </td>
  );

  for (let col = 0; col < props.columns.length; col++) {
    for (let opt = 0; opt < props.options.length; opt++) {
      elements.push(
        <RadioButton
          key={`${props.questionId}${col}${opt}`}
          value={props.options[opt]}
          optionsIndex={opt}
          optionsLength={props.options.length}
          column={props.columns[col]}
          questionId={props.questionId}
          style={props.style}
        />
      );
    }
  }

  return <tr>{elements}</tr>;
};

RadioButtonGroupRow.propTypes = {
  columns: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  questionId: PropTypes.string.isRequired,
  questionDesc: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/components.js